import type { OcrCustomerContext } from './ocr-customer-context';

export function parseOcrCustomerContext(raw: string | null): OcrCustomerContext | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as OcrCustomerContext;
  } catch {
    return null;
  }
}
